module.exports = __webpack_public_path__ + "img/actionable_gammification.0c3c322c.jpg";